import React, { useState } from 'react';
// import { Link } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { emailApi, type GenerateVerifyEmailRequest } from '../api/emailApi';
import { AuthContainer } from '../components/index';
import { Navbar } from '../../../shared/components/layout';
import { Toast } from '../../../shared/components/ui';

export const ConfirmEmailPage: React.FC = () => {
  const [email] = useState('you@example.com');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const resendMutation = useMutation({
    mutationFn: (data: GenerateVerifyEmailRequest) => emailApi.generateVerifyEmail(data),
    onSuccess: (response) => {
      if (response.success) {
        setToastMessage('Verification link sent successfully!');
        setShowToast(true);
      }
    },
    onError: (error: any) => {
      const message = error.response?.data?.message || 'Failed to send verification link';
      setToastMessage(message);
      setShowToast(true);
    },
  });

  const handleResend = () => {
    resendMutation.mutate({ email });
  };

  const handleChangeEmail = () => {
    setToastMessage('Redirecting to sign up...');
    setShowToast(true);
    // In a real app, you might redirect to a change email page or sign up
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex items-center justify-center min-h-[calc(100vh-80px)] px-4">
        <AuthContainer>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Confirm your email</h1>
            <p className="text-gray-600 mb-6">
              Click the link in the email we sent to:{' '}
              <span className="font-medium text-blue-600">{email}</span>{' '}
              to activate your account.
            </p>
            <div className="space-y-3">
              <button
                onClick={handleResend}
                disabled={resendMutation.isPending}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {resendMutation.isPending ? 'Sending...' : 'Resend link'}
              </button>
              <button
                onClick={handleChangeEmail}
                className="w-full text-gray-600 hover:text-gray-700 transition-colors"
              >
                Change email address
              </button>
            </div>
          </div>
        </AuthContainer>
      </div>
      {showToast && (
        <Toast
          id="confirm-email-toast"
          title="Notification"
          message={toastMessage}
          type="success"
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
};
